import { useSelector } from 'react-redux';
import {
  getManageStanadardApiKeys,
  getChosenBusiness,
  getManageOauthAuthorizations,
  getManageIntegrationSecrets,
} from 'store/authentication/selectors';
import { APIKeys } from './APIKeys';
import { OAuth } from './OAuth';
import Cols from 'components/Layout/Cols';
import { StyledCard, StyledSection } from './styles';
import { ContentWidth } from 'components/Layout/PageContentWidth';
import { IntegrationSecrets } from './IntegrationSecrets';

const ManageConnections = () => {
  const chosenBusiness = useSelector(getChosenBusiness);
  const manageAPIKeysAccess = useSelector(getManageStanadardApiKeys);
  const manageOauthAuthorizationsAccess = useSelector(
    getManageOauthAuthorizations
  );
  const manageIntegrationSecretsAccess = useSelector(
    getManageIntegrationSecrets
  );

  return (
    <StyledSection data-qa="manage-connections">
      <ContentWidth>
        <Cols columns={2} gutter={'20px'}>
          {manageAPIKeysAccess?.view ? (
            <StyledCard data-qa="manage-connections__api-keys">
              <APIKeys
                businessId={chosenBusiness.id}
                access={manageAPIKeysAccess}
              />
            </StyledCard>
          ) : null}
          {manageOauthAuthorizationsAccess?.view ? (
            <StyledCard data-qa="manage-connections__oauth">
              <OAuth access={manageOauthAuthorizationsAccess} />
            </StyledCard>
          ) : null}
        </Cols>
        {manageIntegrationSecretsAccess?.view ? (
          <StyledCard data-qa="manage-connections__integration-secrets">
            <IntegrationSecrets access={manageIntegrationSecretsAccess} />
          </StyledCard>
        ) : null}
      </ContentWidth>
    </StyledSection>
  );
};

export default ManageConnections;
